export const FLOW_SPECIALIST_ROLE_NAMES = [
  "Specialist-Pre-Manager",
  "Specialist-Coordinator",
  "Specialist-Manager",
  "Specialist-Validator",
  "Specialist-Verificator",
  "Specialist-Editor",
  "Specialist-Liaison"
];

export const FLOW_SPECIALIST_ROLE_KEYS = {
  "Specialist-Pre-Manager": "pre-manager",
  "Specialist-Coordinator": "coordinator",
  "Specialist-Manager": "manager",
  "Specialist-Validator": "validator",
  "Specialist-Verificator": "validator",
  "Specialist-Editor": "editor",
  "Specialist-Liaison": "liaison",
  "Specialist-Feeder": "feeder"
};

export const CMI_SPECIALIST_USER_ROLE_KEYS = ["pre-manager", "coordinator", "manager", "validator", "verificator", "editor", "liaison", "feeder"];

export const flowCaseKey = (row = {}) => (
  `${row.subject_kind || "case"}:${row.process || ""}:${row.id}`
);

export const formatFilteredPair = (visible, universe, filtered) => {
  if (!filtered) {
    return String(universe ?? 0);
  }
  return `${visible ?? 0} de ${universe ?? 0}`;
};

export const formatSpecialistUserLabel = (user) => {
  if (!user) {
    return "";
  }
  const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
  const handle = user.user_name || user.username || "";
  if (name && handle) {
    return `${name} (${handle})`;
  }
  return name || handle || user.email || (user.id ? `#${user.id}` : "");
};

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const resolveCiiuId = (row = {}) => toNumber(row.catalogciius_id || row.catalogciiu_id);

const isPublishedOperatorRole = (roleKey = "") => {
  const key = String(roleKey || "").trim().toLowerCase();
  return key === "coordinator" || key === "liaison" || key.includes("enlace");
};

export const summarizeCaseMassSelection = (records = [], { roleKey = "" } = {}) => {
  if (!records.length) {
    return {
      mixed: false,
      sameModule: true,
      sameState: true,
      sameCiiu: true,
      sameTray: true,
      canFlow: false,
      canReassign: false,
      anyPublished: false,
      process: "",
      roleId: 0,
      ciiuId: 0,
      stateId: 0
    };
  }

  const process = records[0].process || "";
  const stateId = toNumber(records[0].state_catalog_id);
  const ciiuId = resolveCiiuId(records[0]);
  const roleId = toNumber(records[0].current_role_catalog_id);
  const sameModule = records.every((row) => String(row.process || "") === String(process));
  const sameState = records.every((row) => toNumber(row.state_catalog_id) === stateId);
  const sameCiiu = records.every((row) => resolveCiiuId(row) === ciiuId);
  const sameTray = Boolean(roleId) && records.every((row) => toNumber(row.current_role_catalog_id) === roleId);
  const kind = records[0].subject_kind || "case";
  const sameKind = records.every((row) => (row.subject_kind || "case") === kind);
  const anyPublished = records.some((row) => row.published_at);
  const publishedOperator = isPublishedOperatorRole(roleKey);

  return {
    mixed: !(sameModule && sameState && sameKind),
    sameModule,
    sameState,
    sameCiiu,
    sameTray,
    sameKind,
    canFlow: sameModule && sameState && sameKind && (!anyPublished || publishedOperator),
    canReassign: sameModule && sameState && sameCiiu && sameTray && !anyPublished && Boolean(ciiuId),
    anyPublished,
    process,
    roleId,
    ciiuId,
    stateId
  };
};

export const EMPTY_CMI_AGGREGATES = {
  total: 0,
  published: 0,
  inTray: 0,
  traysWithLoad: 0,
  modulesWithResults: 0,
  usersWithCases: 0,
  pending: 0
};
